import { render } from "./DietPanel.vue?vue&type=template&id=e2048a8c"
import script from "./DietPanel.vue?vue&type=script&lang=js"
export * from "./DietPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__